import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEtc_list, addEtc, removeEtc } from '../../store';
import config from '../../config';
import axios from 'axios';

function EtcSetting() {
  const dispatch = useDispatch();

  const settingList = useSelector((state) => state.settingList || {});
  const Etc_list = useSelector((state) => state.Etc_list || {});

  const [inputcommPort, setcommPort] = useState('RS485-CH1');
  const [inputId, setInputId] = useState('1');
  const [inputName, setInputName] = useState('기타1');
  const [inputProtocol, setInputProtocol] = useState('JK진동V1');
  const [inputIP, setInputIP] = useState('192.168.105.101');
  const [inputPort, setInputPort] = useState('502');
  const [inputEtc_EtcSetting, setInputEtc_EtcSetting] = useState('100.000');

  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const { etcMeter_protocolList = [], commPortList = [] } = settingList;

  // 최초 장비 리스트 불러오기
  useEffect(() => {
    dispatch(fetchEtc_list());
  }, [dispatch]);

  // 용량 값이 소수점 두 자리로 유지되도록 제한
  const handleEtc_EtcSettingChange = (e) => {
    let value = e.target.value;
    if (value.includes('.')) {
      const parts = value.split('.');
      if (parts[1].length > 2) {
        value = `${parts[0]}.${parts[1].slice(0, 2)}`;
      }
    }
    setInputEtc_EtcSetting(value);
  };

  const EtcAddclick = async () => {
    // 상태에서 inputId를 사용해 새로운 ID 생성
    const nextId = (parseInt(inputId) + 1).toString();
    const nextName = `${inputName.split(/[0-9]+$/)[0]}${nextId}`;
  
    const newEtc = {
      name: inputName,
      protocol: inputProtocol,
      Etc_EtcSetting: parseFloat(inputEtc_EtcSetting).toFixed(3),
      commPort: inputcommPort,
      id: inputId,  // inputId가 아닌 nextId를 사용
      ip: inputcommPort === 'ETHERNET' ? inputIP : '',  // 이더넷일 때만 IP 설정
      port: inputcommPort === 'ETHERNET' ? inputPort : null,  // 이더넷일 때만 포트 설정
    };
  
    try {
      const response = await axios.post(`${config.backendUrl}/api/Etc`, newEtc);
      if (response.status === 201 || response.status === 200) {
        // console.log('Etc added successfully:', response.data); 
  
        // Redux와 로컬 상태 동기화
        const pr1 = dispatch(fetchEtc_list());
        dispatch(addEtc(newEtc));
  
        // 로컬 상태 업데이트: 다음 아이디와 초기값 설정
        setInputId(nextId);
        setInputName(nextName);
        // IP 자동 증가 제거: 기존 입력값 유지
        setInputIP(inputIP);
        setInputPort('502');
        setInputEtc_EtcSetting('0');
  

      } else {
        console.error('Failed to add Etc:', response);
      }
    } catch (error) {
      console.error('An error occurred while adding Etc:', error);
    }
  };
  

  const handleEditClick = (port, index) => {
    if (!Etc_list || !Etc_list.Etc_commPort || !Etc_list.Etc_commPort[index]) {
      console.error('Invalid Etc_list data at port:', port, 'index:', index);
      return;
    }

    let Etc = {};

    if (Etc_list.Etc_commPort[index] === 'ETHERNET') {
      Etc = {
        id: Etc_list.Etc_address[index] || '',
        name: Etc_list.Etc_name[index] || '',
        protocol: Etc_list.Etc_protocol[index] || '',
        ip: Etc_list.Etc_ethernetIp && Etc_list.Etc_ethernetIp[index] ? Etc_list.Etc_ethernetIp[index] : '',
        port: Etc_list.Etc_ethernetPort && Etc_list.Etc_ethernetPort[index] ? Etc_list.Etc_ethernetPort[index] : '',
        EtcSetting: Etc_list.Etc_EtcSetting[index] || '0',
      };
    } else {
      Etc = {
        id: Etc_list.Etc_address[index] || '',
        name: Etc_list.Etc_name[index] || '',
        protocol: Etc_list.Etc_protocol[index] || '',
        ip: '0',
        port: '0',
        EtcSetting: Etc_list.Etc_EtcSetting[index] || '0',
      };
    }

    setEditIndex(index);
    setcommPort(Etc_list.Etc_commPort[index]);
    setInputId(Etc.id);
    setInputName(Etc.name);
    setInputProtocol(Etc.protocol);
    setInputIP(Etc.ip);
    setInputPort(Etc.port);
    setInputEtc_EtcSetting(Etc.EtcSetting);

    setIsEditing(true);
    setShowModal(true);
  };

  const handleSaveClick = async () => {
    const updatedEtc = {
      id: inputId,
      name: inputName,
      protocol: inputProtocol,
      ip: inputcommPort === 'ETHERNET' ? inputIP : '',
      port: inputcommPort === 'ETHERNET' ? inputPort : '',
      Etc_EtcSetting: parseFloat(inputEtc_EtcSetting).toFixed(3),
      commPort: inputcommPort,
    };
  
    const seq = Etc_list.seq[editIndex]; // 수정할 장비의 seq 값 가져오기
  
    try {
      // 서버에 업데이트 요청
      const response = await axios.put(`${config.backendUrl}/api/update_Etc/${seq}`, updatedEtc);
      if (response.status === 200) {
        // console.log('Etc updated successfully:', response.data);
        
        // Redux 상태 갱신
        dispatch(fetchEtc_list()); // 리스트 다시 불러오기
      } else {
        console.error('Failed to update Etc:', response);
      }
    } catch (error) {
      console.error('An error occurred while updating Etc:', error);
    }
  
    // 입력 필드 초기화 및 모달 닫기
    setEditIndex(null);
    setInputId('');
    setInputName('');
    setInputProtocol('');
    setInputIP('');
    setInputPort('');
    setInputEtc_EtcSetting('0');
    setcommPort('RS485-CH1');
    setShowModal(false);
  };
  
  

  const handleDeleteClick = (port, index) => {
    if (Etc_list.Etc_commPort[index] === port) {
      const confirmDelete = window.confirm(`${Etc_list.Etc_name[index]}을(를) 정말로 삭제하시겠습니까? 삭제 후 복원할 수 없습니다.`);
      if (confirmDelete) {
        axios
          .delete(`${config.backendUrl}/api/Etc/${Etc_list.seq[index]}`)
          .then((response) => {
            dispatch(removeEtc({ port, index }));
            window.alert(`${Etc_list.Etc_name[index]} 삭제 완료`);
          })
          .catch((error) => {
            console.error('삭제 중 오류 발생:', error);
          });
      }
    } else {
      console.error('Invalid index or port:', port, index);
    }
  };

  const handleRowClick = (commPort) => {
    let url = '';

    switch (commPort) {
      case 'RS485-CH1':
        url = `${config.backendUrl}/RS485-CH1`;
        break;
      case 'RS485-CH2':
        url = `${config.backendUrl}/RS485-CH2`;
        break;
      case 'RS485-CH3':
        url = `${config.backendUrl}/RS485-CH3`;
        break;
      case 'ETHERNET':
        url = `${config.backendUrl}/ETHERNET`;
        break;
      default:
        return;
    }

    window.open(url, '_blank');
  };

  return (
    <Container className="mt-5">
      <Row className="align-items-center justify-content-center mb-3">
        <Col md="2">
          <Form.Label className="text-center w-100">통신 포트</Form.Label>
          <Form.Control as="select" value={inputcommPort} onChange={(e) => setcommPort(e.target.value)} className="text-center">
            {commPortList.map((port, index) => (
              <option key={index} value={port}>
                {port}
              </option>
            ))}
          </Form.Control>
        </Col>
        {inputcommPort === 'ETHERNET' && (
          <>
            <Col md="2">
              <Form.Label className="text-center w-100">IP 주소</Form.Label>
              <Form.Control
                type="text"
                value={inputIP}
                onChange={(e) => setInputIP(e.target.value)}
                className="text-center"
                placeholder="192.168.105.101"
              />
            </Col>
            <Col md="1">
              <Form.Label className="text-center w-100">포트</Form.Label>
              <Form.Control
                type="text"
                value={inputPort}
                onChange={(e) => setInputPort(e.target.value)}
                className="text-center"
                placeholder="502"
              />
            </Col>
          </>
        )}
        <Col md="1">
          <Form.Label className="text-center w-100">장비 ID</Form.Label>
          <Form.Control type="text" value={inputId} onChange={(e) => setInputId(e.target.value)} className="text-center" />
        </Col>
        <Col md="2">
          <Form.Label className="text-center w-100">기타 이름</Form.Label>
          <Form.Control type="text" value={inputName} onChange={(e) => setInputName(e.target.value)} className="text-center" />
        </Col>
        <Col md="2">
          <Form.Label className="text-center w-100">프로토콜 선택</Form.Label>
          <Form.Control as="select" value={inputProtocol} onChange={(e) => setInputProtocol(e.target.value)} className="text-center">
            {etcMeter_protocolList.map((protocol, index) => (
              <option key={index} value={protocol}>
                {protocol}
              </option>
            ))}
          </Form.Control>
        </Col>

        <Col md="2" className="text-center">
          <Button variant="info" onClick={EtcAddclick} className="mt-4 w-100">
            기타 추가
          </Button>
        </Col>
      </Row>

      {Array.from(new Set(Etc_list.Etc_commPort)).map((port) => (
        <div key={port}>
          <Table striped bordered hover className="text-center">
            <thead>
              <tr>
                <th>#</th>
                <th onClick={() => handleRowClick(port)} style={{ cursor: 'pointer' }}>
                  {port}
                </th>
                <th>장비 ID</th>
                <th>기타 이름</th>
                <th>프로토콜</th>
                {port === 'ETHERNET' && (
                  <>
                    <th>IP 주소</th>
                    <th>포트</th>
                  </>
                )}
                <th>송신</th>
                <th>수신</th>
                <th>수정</th>
                <th>삭제</th>
              </tr>
            </thead>
            <tbody>
              {Etc_list.Etc_commPort.map((commPort, index) => {
                if (commPort === port) {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{Etc_list.Etc_commPort[index]}</td>
                      <td>{Etc_list.Etc_address[index]}</td>
                      <td>{Etc_list.Etc_name[index]}</td>
                      <td>{Etc_list.Etc_protocol[index]}</td>
                      {port === 'ETHERNET' && (
                        <>
                          <td>{Etc_list.Etc_ethernetIp && Etc_list.Etc_ethernetIp[index]}</td>
                          <td>{Etc_list.Etc_ethernetPort && Etc_list.Etc_ethernetPort[index]}</td>
                        </>
                      )}
                      <td>{Etc_list.Etc_sendCount ? Etc_list.Etc_sendCount[index] : 'N/A'}</td>
                      <td>{Etc_list.Etc_receiveCount ? Etc_list.Etc_receiveCount[index] : 'N/A'}</td>
                      <td>
                        <Button
                          variant="warning"
                          style={{ padding: '5px 5px', fontSize: '10px', lineHeight: '0.8' }}
                          onClick={() => handleEditClick(port, index)}
                        >
                          수정
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="danger"
                          style={{ padding: '5px 5px', fontSize: '10px', lineHeight: '0.8' }}
                          onClick={() => handleDeleteClick(port, index)}
                        >
                          삭제
                        </Button>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </Table>
        </div>
      ))}

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>기타 수정</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>통신 포트</Form.Label>
              <Form.Control as="select" value={inputcommPort} onChange={(e) => setcommPort(e.target.value)} className="text-center">
                {commPortList.map((port, index) => (
                  <option key={index} value={port}>
                    {port}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            {inputcommPort === 'ETHERNET' && (
              <>
                <Form.Group>
                  <Form.Label>IP 주소</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputIP}
                    onChange={(e) => setInputIP(e.target.value)}
                    className="text-center"
                    placeholder="192.168.105.101"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>포트</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputPort}
                    onChange={(e) => setInputPort(e.target.value)}
                    className="text-center"
                    placeholder="502"
                  />
                </Form.Group>
              </>
            )}
            <Form.Group>
              <Form.Label>장비ID(어드레스)</Form.Label>
              <Form.Control
                type="text"
                value={inputId}
                onChange={(e) => setInputId(e.target.value)}
                className="text-center"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>기타 이름</Form.Label>
              <Form.Control
                type="text"
                value={inputName}
                onChange={(e) => setInputName(e.target.value)}
                className="text-center"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>프로토콜 선택</Form.Label>
              <Form.Control
                as="select"
                value={inputProtocol}
                onChange={(e) => setInputProtocol(e.target.value)}
                className="text-center"
              >
                {etcMeter_protocolList.map((protocol, index) => (
                  <option key={index} value={protocol}>
                    {protocol}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            취소
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            저장
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default EtcSetting;
